import { useMemo, useEffect } from 'react';
import { useAppSelector } from '../store';
import { prepareFetchParameters } from '../utils/functions';
import { IPrepareFetchParamsOptions } from '../types';

export function useSetOrganizationOnOpen(
  open: boolean,
  values: { organization: number },
  setFieldValue: (field: string, value: number) => void,
) {
  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  useEffect(() => {
    if (open && !values.organization && !!organization) {
      if (organization !== 1) {
        setFieldValue('organization', organization);
      }
    }
  }, [open, values.organization, organization]);
}

const useFetchParameters = ({
  page,
  search,
  sort,
  dates,
  isExpired,
  onlyOpen,
}: IPrepareFetchParamsOptions): string => {
  return useMemo(() => {
    return prepareFetchParameters({
      page,
      search,
      sort,
      dates,
      isExpired,
      onlyOpen,
    });
  }, [page, search, sort, dates, isExpired, onlyOpen]);
};

export default useFetchParameters;
